import React from 'react';
/*
import {
  hf,
  ht,
  cr,
  a,
  f,
  ls,
  gs,
  useMsgz,
  useLdrz,
  BoxC,
  BtnC,
  GridC,
  IptC,
  LblC,
  MsgC,
  _cv_10___Mz,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as GridC from "./_cccGridC";
import * as BtnC from "./_cccBtnC";
import * as LblC from "./_cccLblC";
import * as MsgC from "./_cccMsgC";
import * as cmFTH from "./_cmFTH"; // 廃止予定
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import { useLdrz } from "./_csLdr";
import { useMsgz } from "./_csMdlMsg";
import * as ht from './_ht';
import * as hf from './_hf';

import * as icvI18___Mz from './icvI18___Mz';

let $i18z = icvI18___Mz.ilzI18z();
//let $_101z = _cv_10___Mz.crt_101z();
let $id1 = '';
let $pwd11 = '';
let $pwd12 = '';
let $id2 = '';
let $pwd21 = '';
let $pwd22 = '';
let $id3 = '';
let $pwd31 = '';
let $pwd32 = '';

export const N = (pz: {
  sPz: ht.dz,
}) => {

  const _gUserz = gs.useUserz();
  const _i19ra1220i = _gUserz.crt.i19rz?.i19ra1220i;

  const _udtThis = ls.udtThis();
  const _sMsgz = useMsgz();
  const _sLdrz = useLdrz();

  React.useEffect(() => {
    if (_gUserz.crt._10rz._key > 0) {
      cmFTH.loadAllAsync({
        frcUdt: _udtThis,
        bfrAsync: () => [
          icvI18___Mz.loadI18rDzAsync({
            i18r_fst: _gUserz.crt.i18rz._fst,
          })
            .then((_dz: ht.dz) => {
              $i18z = _dz;
              $id1 = $i18z.i18rz.i18ra4120s;
              $pwd11 = $i18z.i18rz.i18ra4130s;
              $pwd12 = $i18z.i18rz.i18ra4130s;
              $id2 = $i18z.i18rz.i18ra4220s;
              $pwd21 = $i18z.i18rz.i18ra4230s;
              $pwd22 = $i18z.i18rz.i18ra4230s;
              $id3 = $i18z.i18rz.i18ra4320s;
              $pwd31 = $i18z.i18rz.i18ra4330s;
              $pwd32 = $i18z.i18rz.i18ra4330s;
            }),
        ]
      })
    }
  }, [
    _gUserz.crt.i18rz._fst
  ])

  const _send = async () => {
    _sLdrz.show();
    const _b = await hf.ectSrlAsync([
      /*
            async () => {
              let _b = true;
              if ( _i19ra1220i == 20 ) {
                if (
                  !hf.f($id1) && !hf.f($id2) && !hf.f($id3)
                ) _b = false;
              }
              if (!_b) {
                _sMsgz.show({
                  textCz: {
                    textz: {
                      pfx: `ログインIDを1つ以上入力してください`
                    }
                  }
                })
              }
              return _b;
            },
            async () => {
              let _b = true;
              if ( _i19ra1220i == 20 ) {
                if (
                    (hf.f($id1) && $id1 == $id2) ||
                    (hf.f($id1) && $id1 == $id3) ||
                    (hf.f($id2) && $id2 == $id3)
                ) _b = false;
              }
              if (!_b) {
                _sMsgz.show({
                  textCz: {
                    textz: {
                      pfx: `ログインIDが重複しています`
                    }
                  }
                })
              }
              return _b;
            },
            async () => {
              let _b = true;
              if ( _i19ra1220i == 20 ) {
                if (
                  (hf.f($id1) && !hf.chkHkk($id1, true)) ||
                  (hf.f($id2) && !hf.chkHkk($id2, true)) ||
                  (hf.f($id3) && !hf.chkHkk($id3, true))
                ) _b = false;
              }
              if (!_b) {
                _sMsgz.show({
                  textCz: {
                    textz: {
                      pfx: `ログインIDは、半角英数字を入力してください`
                    }
                  }
                })
              }
              return _b;
            },
            async () => {
              let _b = true;
              if ( _i19ra1220i == 20 ) {
                let _cdn = f.vdd(false) + ` AND _icn NOT LIKE '${_gUserz.crt.i18rz._fst}_%'`;
                let _cdn2 = '';
                if (hf.f($id1)) _cdn2 += (_cdn2 != '' ? ` OR ` : ``) + `_10ra2100s='${$id1}'`;
                if (hf.f($id2)) _cdn2 += (_cdn2 != '' ? ` OR ` : ``) + `_10ra2100s='${$id2}'`;
                if (hf.f($id3)) _cdn2 += (_cdn2 != '' ? ` OR ` : ``) + `_10ra2100s='${$id3}'`;
                _cdn += ` AND (${_cdn2})`;
                const _ls = await _cv_10___Mz.load_10rLsAsync({
                  cdn: _cdn,
                })
                if (
                  _ls.length > 0
                ) _b = false;
              }
              if (!_b) {
                _sMsgz.show({
                  textCz: {
                    textz: {
                      pfx: `他の団体と異なるログインIDを入力してください`
                    }
                  }
                })
              }
              return _b;
            },
            async () => {
              let _b = true;
              if (
                !hf.chkHkk($pwd11, true) ||
                !hf.chkHkk($pwd21, true) ||
                !hf.chkHkk($pwd31, true)
              ) _b = false;
              if (!_b) {
                _sMsgz.show({
                  textCz: {
                    textz: {
                      pfx: `パスワードは、半角英数字を入力ください`
                    }
                  }
                })
              }
              return _b;
            },
            async () => {
              let _b = true;
              if (
                (hf.f($id1) && $pwd11.length < 6) ||
                (hf.f($id2) && $pwd21.length < 6) ||
                (hf.f($id3) && $pwd31.length < 6)
              ) _b = false;
              if (!_b) {
                _sMsgz.show({
                  textCz: {
                    textz: {
                      pfx: `パスワードは、6文字以上を入力ください`
                    }
                  }
                })
              }
              return _b;
            },
      */
      async () => {
        let _b = true;
        if (
          $pwd11 != $pwd12 ||
          $pwd21 != $pwd22 ||
          $pwd31 != $pwd32
        ) _b = false
        if (!_b) {
          _sMsgz.show({
            textCz: {
              textz: {
                pfx: `再入力したパスワードが変更後のパスワードと異なります`
              }
            }
          })
        }
        return _b;
      },
    ])
    if (_b) {
      hf.udtDz($i18z.i18rz, {
        i18ra4120s: $id1,
        i18ra4220s: $id2,
        i18ra4320s: $id3,
        i18ra4130s: $pwd11,
        i18ra4230s: $pwd21,
        i18ra4330s: $pwd31,
      });
      const _b = await icvI18___Mz.chkI18zAsync({
        role: 'd',
        i18z: $i18z,
        sMsgz: _sMsgz,
      });
      if (_b) {
        await icvI18___Mz.saveI18rDzAsync({
          i18z: $i18z,
        });
        _sLdrz.hide();
        if (pz.sPz.crt.ctt == 's') {
          pz.sPz.set({
            steps: [0],
          });
        }
        if (pz.sPz.crt.ctt == 'i') {
          pz.sPz.set({
            steps: [2],
          });
        }
      }
      else {
        _sLdrz.hide();
      }
    }
    else {
      _sLdrz.hide();
    }
  };

  return (

    cr.c(BoxC.N, {
      key: -10,
      boxStlz: a('dwx/120 dw/f fd/csc mh/a'),
      oClds: [

        cr.c(LblC.N, {
          key: -10,
          boxStlz: a(`dw/f mb/2`),
          lblCz: {
            boxStlz: a(`dw/f fd/rcc mb/2`),
            textz: {
              pfx:
                _i19ra1220i == 20 && pz.sPz.crt.ctt == 's' ?
                  'ログインID・パスワード変更'
                  : _i19ra1220i == 20 && pz.sPz.crt.ctt == 'i' ?
                    'ログインID・パスワード登録'
                    : _i19ra1220i == 30 && pz.sPz.crt.ctt == 's' ?
                      'パスワード変更'
                      : _i19ra1220i == 30 && pz.sPz.crt.ctt == 'i' ?
                        'パスワード登録'
                        : '',
              stlz: a(`tb ts/l`),
            }
          },
          cttCz: {
            boxStlz: a(`dw/f fd/csc`),
            oClds: [

              hf.i(pz.sPz.crt.ctt, ['i', 's']) ?
                cr.c(MsgC.N, {
                  key: -10,
                  boxStlz: a(`dwx/100`),
                  cz: {
                    ls: [
                      {
                        mkrCz: {
                          textz: {
                            pfx: '・',
                          }
                        },
                        msgCz: {
                          textz: {
                            pfx:
                              _i19ra1220i == 20 ?
                                '施設予約に利用したいログインID・パスワードを入力してください。'
                                : _i19ra1220i == 30 ?
                                  '施設予約に利用したいパスワードを入力してください。'
                                  : '',
                          }
                        }
                      },
                    ]
                  }
                })
                : null,

              hf.i(pz.sPz.crt.ctt, ['i', 's']) ?
                cr.c(MsgC.N, {
                  key: -20,
                  boxStlz: a(`dwx/100 mb/2 p/2`),
                  cz: {
                    ls: [
                      _i19ra1220i == 20 ?
                        {
                          mkrCz: {
                            textz: {
                              pfx: '※',
                              //stlz: a('ts/s'),
                            }
                          },
                          msgCz: {
                            textz: {
                              //pfx: `ログインIDは、半角英数字（大文字・小文字）、半角記号にて８文字以上３０字以内で入力してください。（半角記号の、「,（カンマ）」・「'（アポストロフィー）」は使用不可）`,
                              pfx: `ログインIDは、半角英数字（大文字・小文字）、半角記号にて５文字以上３０字以内で入力してください。（半角記号の、「,（カンマ）」・「'（アポストロフィー）」は使用不可）`,
                              //stlz: a('ts/s'),
                            }
                          }
                        }
                        : undefined,
                      {
                        mkrCz: {
                          textz: {
                            pfx: '※',
                            //stlz: a('ts/s'),
                          }
                        },
                        msgCz: {
                          textz: {
                            pfx: `パスワードは、半角英数字6文字以上20文字以内で入力してください。`,
                            //stlz: a('ts/s'),
                          }
                        }
                      },
                      {
                        mkrCz: {
                          textz: {
                            pfx: '※',
                            //stlz: a('ts/s'),
                          }
                        },
                        msgCz: {
                          textz: {
                            pfx: `パスワードを入力する際は、コピー＆ペーストを行わないでください。`,
                            //stlz: a('ts/s'),
                          }
                        }
                      },
                    ]
                  }
                })
                : null,

              cr.c(GridC.N, {
                key: -40,
                abtType: 'nolineCmnz',
                boxStlz: a(`dwx/75 f/n`),
                lineCs: [
                  hf.i(_i19ra1220i, [20]) && pz.sPz.crt.ctt == 's' ?
                    {
                      boxStlz: a(`mb/1`),
                      cellCs: [
                        {
                          oClds: [
                            cr.c(LblC.N, {
                              key: -10,
                              abtType: cr.d('p') ? '_hzlz' : `_vclz`,
                              lblCz: {
                                boxStlz: a(`dw/35`),
                                textz: {
                                  pfx: '現在のログインID：',
                                }
                              },
                              cttCz: {
                                oClds: [
                                  cr.c(IptC.S, {
                                    key: -10,
                                    cz: {
                                      bEdit: false,
                                      iptType: 'text',
                                      vle: $i18z.i18rz.i18ra4120s,
                                    },
                                  }),

                                ]
                              }
                            })
                          ]
                        },
                      ]
                    }
                    : null,
                  hf.i(_i19ra1220i, [20]) ?
                    {
                      boxStlz: a(`mb/1`),
                      cellCs: [
                        {
                          oClds: [
                            cr.c(LblC.N, {
                              key: -10,
                              abtType: cr.d('p') ? '_hzlz' : `_vclz`,
                              lblCz: {
                                boxStlz: a(`dw/35`),
                                textz: {
                                  pfx:
                                    pz.sPz.crt.ctt == 's' ?
                                      '変更：'
                                      : pz.sPz.crt.ctt == 'i' ?
                                        '登録するログインID：'
                                        : '',
                                }
                              },
                              cttCz: {
                                oClds: [
                                  cr.c(IptC.S, {
                                    key: -10,
                                    cz: {
                                      bEdit: true,
                                      iptType: 'text',
                                      vle: $id1,
                                      onChg: (_s: ht.s) => {
                                        $id1 = _s;
                                      }
                                    },
                                  }),
                                ]
                              }
                            })
                          ]
                        },
                      ]
                    }
                    : null,
                  {
                    //                    boxStlz: a(`mb/1`),
                    boxStlz: a(`bc/lt9 bs/ds bwt/0.5 dwx/75 f/n mv/1 pt/2`),
                    cellCs: [
                      {
                        oClds: [
                          cr.c(LblC.N, {
                            key: -10,
                            abtType: cr.d('p') ? '_hzlz' : `_vclz`,
                            lblCz: {
                              boxStlz: a(`dw/35`),
                              //                              boxStlz: a(`bc/lt9 bs/ds bwt/0.5 dwx/75 f/n mt/1 pt/2`),
                              textz: {
                                pfx:
                                  pz.sPz.crt.ctt == 's' ?
                                    'パスワード変更：'
                                    : pz.sPz.crt.ctt == 'i' ?
                                      '登録するパスワード：'
                                      : ''
                              }
                            },
                            cttCz: {
                              oClds: [
                                cr.c(IptC.S, {
                                  key: -10,
                                  cz: {
                                    bEdit: true,
                                    bScr: true,
                                    iptType: 'text',
                                    vle: $pwd11,
                                    onChg: (_s: ht.s) => {
                                      $pwd11 = _s;
                                    }
                                  },
                                }),
                              ]
                            }
                          })
                        ]
                      },
                    ]
                  },
                  {
                    boxStlz: a(`mb/1`),
                    cellCs: [
                      {
                        oClds: [
                          cr.c(LblC.N, {
                            key: -10,
                            abtType: cr.d('p') ? '_hzlz' : `_vclz`,
                            lblCz: {
                              boxStlz: a(`dw/35`),
                              textz: {
                                //pfx: 'パスワード変更の再入力：'
                                pfx: 'パスワードの再入力：'
                              }
                            },
                            cttCz: {
                              oClds: [
                                cr.c(IptC.S, {
                                  key: -10,
                                  cz: {
                                    bEdit: true,
                                    bScr: true,
                                    iptType: 'text',
                                    vle: $pwd12,
                                    onChg: (_s: ht.s) => {
                                      $pwd12 = _s;
                                    }
                                  },
                                }),

                              ]
                            }
                          })
                        ]
                      },
                    ]
                  },
                ]
              }),

              /*
                            hf.i(_i19ra1220i, [20]) ?
                            cr.c(GridC.N, {
                              key: -50,
                              abtType: 'nolineCmnz',
                              boxStlz: a(`bc/lt9 bs/ds bwt/0.5 dwx/75 f/n mt/1 pt/2`),
                              lineCs: [
                                pz.sPz.crt.ctt == 's' ?
                                {
                                  boxStlz: a(`mb/1`),
                                  cellCs: [
                                    {
                                      oClds: [
                                        cr.c(LblC.N, {
                                          key: -10,
                                          abtType: cr.d('p') ? '_hzlz' : `_vclz`,
                                          lblCz: {
                                            boxStlz: a(`dw/35`),
                                            textz: {
                                              pfx: '現在のログインID２：',
                                            }
                                          },
                                          cttCz: {
                                            oClds: [
                                              cr.c(IptC.S, {
                                                key: -10,
                                                cz: {
                                                  bEdit: false,
                                                  iptType: 'text',
                                                  vle: $i18z.i18rz.i18ra4220s,
                                                },
                                              }),
              
                                            ]
                                          }
                                        })
                                      ]
                                    },
                                  ]
                                }
                                : null,
                                {
                                  boxStlz: a(`mb/1`),
                                  cellCs: [
                                    {
                                      oClds: [
                                        cr.c(LblC.N, {
                                          key: -10,
                                          abtType: cr.d('p') ? '_hzlz' : `_vclz`,
                                          lblCz: {
                                            boxStlz: a(`dw/35`),
                                            textz: {
                                              pfx:
                                                pz.sPz.crt.ctt == 's' ?
                                                  '変更後のログインID２：'
                                                : pz.sPz.crt.ctt == 'i' ?
                                                  '登録するログインID２：'
                                                : '',
                                            }
                                          },
                                          cttCz: {
                                            oClds: [
                                              cr.c(IptC.S, {
                                                key: -10,
                                                cz: {
                                                  bEdit: true,
                                                  iptType: 'text',
                                                  vle: $id2,
                                                  onChg: (_s: ht.s) => {
                                                    $id2 = _s;
                                                  }
                                                },
                                              }),
                                            ]
                                          }
                                        })
                                      ]
                                    },
                                  ]
                                },
                                {
                                  boxStlz: a(`mb/1`),
                                  cellCs: [
                                    {
                                      oClds: [
                                        cr.c(LblC.N, {
                                          key: -10,
                                          abtType: cr.d('p') ? '_hzlz' : `_vclz`,
                                          lblCz: {
                                            boxStlz: a(`dw/35`),
                                            textz: {
                                              pfx:
                                                pz.sPz.crt.ctt == 's' ?
                                                  '変更後のパスワード２：'
                                                : pz.sPz.crt.ctt == 'i' ?
                                                  '登録するパスワード２：'
                                                : '',
                                            }
                                          },
                                          cttCz: {
                                            oClds: [
                                              cr.c(IptC.S, {
                                                key: -10,
                                                cz: {
                                                  bEdit: true,
                                                  bScr: true,
                                                  iptType: 'text',
                                                  vle: $pwd21,
                                                  onChg: (_s: ht.s) => {
                                                    $pwd21 = _s;
                                                  }
                                                },
                                              }),
                                            ]
                                          }
                                        })
                                      ]
                                    },
                                  ]
                                },
                                {
                                  boxStlz: a(`mb/1`),
                                  cellCs: [
                                    {
                                      oClds: [
                                        cr.c(LblC.N, {
                                          key: -10,
                                          abtType: cr.d('p') ? '_hzlz' : `_vclz`,
                                          lblCz: {
                                            boxStlz: a(`dw/35`),
                                            textz: {
                                              pfx: '同じパスワード２を再入力：',
                                            }
                                          },
                                          cttCz: {
                                            oClds: [
                                              cr.c(IptC.S, {
                                                key: -10,
                                                cz: {
                                                  bEdit: true,
                                                  bScr: true,
                                                  iptType: 'text',
                                                  vle: $pwd22,
                                                  onChg: (_s: ht.s) => {
                                                    $pwd22 = _s;
                                                  }
                                                },
                                              }),
              
                                            ]
                                          }
                                        })
                                      ]
                                    },
                                  ]
                                },
                              ]
                            })
                            : null,
              
                            hf.i(_i19ra1220i, [20]) ?
                            cr.c(GridC.N, {
                              key: -60,
                              abtType: 'nolineCmnz',
                              boxStlz: a(`bc/lt9 bs/ds bwt/0.5 dwx/75 f/n mt/1 pt/2`),
                              lineCs: [
                                pz.sPz.crt.ctt == 's' ?
                                {
                                  boxStlz: a(`mb/1`),
                                  cellCs: [
                                    {
                                      oClds: [
                                        cr.c(LblC.N, {
                                          key: -10,
                                          abtType: cr.d('p') ? '_hzlz' : `_vclz`,
                                          lblCz: {
                                            boxStlz: a(`dw/35`),
                                            textz: {
                                              pfx: '現在のログインID３：',
                                            }
                                          },
                                          cttCz: {
                                            oClds: [
                                              cr.c(IptC.S, {
                                                key: -10,
                                                cz: {
                                                  bEdit: false,
                                                  iptType: 'text',
                                                  vle: $i18z.i18rz.i18ra4320s,
                                                },
                                              }),
              
                                            ]
                                          }
                                        })
                                      ]
                                    },
                                  ]
                                }
                                : null,
                                {
                                  boxStlz: a(`mb/1`),
                                  cellCs: [
                                    {
                                      oClds: [
                                        cr.c(LblC.N, {
                                          key: -10,
                                          abtType: cr.d('p') ? '_hzlz' : `_vclz`,
                                          lblCz: {
                                            boxStlz: a(`dw/35`),
                                            textz: {
                                              pfx:
                                                pz.sPz.crt.ctt == 's' ?
                                                  '変更後のログインID３：'
                                                : pz.sPz.crt.ctt == 'i' ?
                                                  '登録するログインID３：'
                                                : '',
                                            }
                                          },
                                          cttCz: {
                                            oClds: [
                                              cr.c(IptC.S, {
                                                key: -10,
                                                cz: {
                                                  bEdit: true,
                                                  iptType: 'text',
                                                  vle: $id3,
                                                  onChg: (_s: ht.s) => {
                                                    $id3 = _s;
                                                  }
                                                },
                                              }),
                                            ]
                                          }
                                        })
                                      ]
                                    },
                                  ]
                                },
                                {
                                  boxStlz: a(`mb/1`),
                                  cellCs: [
                                    {
                                      oClds: [
                                        cr.c(LblC.N, {
                                          key: -10,
                                          abtType: cr.d('p') ? '_hzlz' : `_vclz`,
                                          lblCz: {
                                            boxStlz: a(`dw/35`),
                                            textz: {
                                              pfx:
                                                pz.sPz.crt.ctt == 's' ?
                                                  '変更後のパスワード３：'
                                                : pz.sPz.crt.ctt == 'i' ?
                                                  '登録するパスワード３：'
                                                : '',
                                            }
                                          },
                                          cttCz: {
                                            oClds: [
                                              cr.c(IptC.S, {
                                                key: -10,
                                                cz: {
                                                  bEdit: true,
                                                  bScr: true,
                                                  iptType: 'text',
                                                  vle: $pwd31,
                                                  onChg: (_s: ht.s) => {
                                                    $pwd31 = _s;
                                                  }
                                                },
                                              }),
                                            ]
                                          }
                                        })
                                      ]
                                    },
                                  ]
                                },
                                {
                                  boxStlz: a(`mb/1`),
                                  cellCs: [
                                    {
                                      oClds: [
                                        cr.c(LblC.N, {
                                          key: -10,
                                          abtType: cr.d('p') ? '_hzlz' : `_vclz`,
                                          lblCz: {
                                            boxStlz: a(`dw/35`),
                                            textz: {
                                              pfx: '同じパスワード３を再入力：',
                                            }
                                          },
                                          cttCz: {
                                            oClds: [
                                              cr.c(IptC.S, {
                                                key: -10,
                                                cz: {
                                                  bEdit: true,
                                                  bScr: true,
                                                  iptType: 'text',
                                                  vle: $pwd32,
                                                  onChg: (_s: ht.s) => {
                                                    $pwd32 = _s;
                                                  }
                                                },
                                              }),
              
                                            ]
                                          }
                                        })
                                      ]
                                    },
                                  ]
                                },
                              ]
                            })
                            : null,
              */
            ]
          }


        }),

        cr.c(BoxC.N, {
          key: -20,
          boxStlz:
            cr.chkDvc() == 'p' ?
              a(`dw/f fd/rac`)
              : a(`dw/f fd/crac`),
          oClds: [

            cr.c(BtnC.N, {
              key: -10,
              abtType: 'backCmnz',
              boxStlz: a(`dh/10 mb/2`),
              lblCz: {
                textz: {
                  pfx: '前の画面に戻る',
                }
              },
              pslPtyz: {
                onPress: () => {
                  pz.sPz.set({
                    steps: [0],
                  });
                },
              },
            }),

            cr.c(BtnC.N, {
              key: -20,
              abtType: 'stgz',
              boxStlz: a(`dh/10 mb/2`),
              lblCz: {
                textz: {
                  pfx:
                    _i19ra1220i == 20 && pz.sPz.crt.ctt == 's' ?
                      '登録されている\nログインID・パスワードを変更'
                      : _i19ra1220i == 20 && pz.sPz.crt.ctt == 'i' ?
                        'ログインID・パスワードを登録'
                        : _i19ra1220i == 30 && pz.sPz.crt.ctt == 's' ?
                          '登録されているパスワードを変更'
                          : _i19ra1220i == 30 && pz.sPz.crt.ctt == 'i' ?
                            'パスワードを登録'
                            : '',
                }
              },
              pslPtyz: {
                onPress: _send,
              },
            }),

          ]
        })

      ]
    })

  );
};
